<template>
  <v-navigation-drawer
    stateless
    :fixed="true"
    :clipped="true"
    :value="navigationDrawerOpen"
    width="250px"
    app
  >
    <!-- <v-navigation-drawer
    stateless
    :fixed="true"
    :mini-variant="navigationDrawerMini"
    :clipped="true"
    :value="navigationDrawerOpen"
    width="250px"
    app
    >-->
    <v-list>
      <v-list-tile
        v-if="developmentMode != development"
        class="developmentMarker"
      >
        <v-list-tile-action>
          <v-icon>report</v-icon>
        </v-list-tile-action>
        <v-list-tile-title
          >WARNING: Development modes do not match</v-list-tile-title
        >
      </v-list-tile>
      <v-list-tile v-if="developmentMode" class="developmentMarker">
        <v-list-tile-action>
          <v-icon>report</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>DEVELOPMENT</v-list-tile-title>
      </v-list-tile>
      <!-- <v-list-tile @click="toggleNavigationDrawerMini">
        <v-list-tile-action>
          <v-icon v-if="navigationDrawerMini">chevron_right</v-icon>
          <v-icon v-if="!navigationDrawerMini">chevron_left</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Hide navigation</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>-->
      <v-list-group prepend-icon="account_balance">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Accounts</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list>
          <v-list-tile :to="{ name: 'billDiary' }">
            <v-list-tile-title>Bill diary</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>date_range</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'billTemplates' }"
            v-if="$keycloak.hasRealmRole('billadmin')"
          >
            <v-list-tile-title>Bill templates</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>folder</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'ledgers' }">
            <v-list-tile-title>Ledgers</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>account_balance_wallet</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'vatActions' }">
            <v-list-tile-title>VAT actions</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>account_balance_wallet</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-list-group>
      <v-list-group
        prepend-icon="timeline"
        v-if="$keycloak.hasRealmRole('cashflow')"
      >
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Cashflow</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list>
          <v-list-tile :to="{ name: 'cashflowAccounts' }">
            <v-list-tile-title>Accounts</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>folder</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'cashflowCalendar' }">
            <v-list-tile-title>Calendar</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>date_range</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'cashflowCurrencies' }">
            <v-list-tile-title>Currencies</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>attach_money</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'cashflowPurposes' }">
            <v-list-tile-title>Purposes</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>credit_card</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'cashflowRates' }">
            <v-list-tile-title>Rates</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>timeline</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-list-group>
      <v-list-group
        prepend-icon="favorite"
        v-if="$keycloak.hasRealmRole('root')"
      >
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Customer care</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list>
          <v-list-tile :to="{ name: 'colps' }">
            <v-list-tile-title>Colps</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-list-group>
      <v-list-group prepend-icon="contacts">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Directory</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list>
          <v-list-tile
            :to="{ name: 'emailClients' }"
            v-if="$keycloak.hasRealmRole('directoryadmin')"
          >
            <v-list-tile-title>Email clients</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>import_contacts</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'groups' }"
            v-if="$keycloak.hasRealmRole('directoryadmin')"
          >
            <v-list-tile-title>Groups</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>group</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'holidayCalendar' }">
            <v-list-tile-title>Holiday calendar</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>beach_access</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'holidayConflicts' }"
            v-if="$keycloak.hasRealmRole('holidayadmin')"
          >
            <v-list-tile-title>Holiday conflicts</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>block</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'holidayList' }">
            <v-list-tile-title>Holiday list</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'keycloak' }"
            v-if="$keycloak.hasRealmRole('root')"
          >
            <v-list-tile-title>Keycloak</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>vpn_key</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'logAccess' }"
            v-if="$keycloak.hasRealmRole('directoryadmin')"
          >
            <v-list-tile-title>Log access</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>verified_user</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'panelNumbers' }">
            <v-list-tile-title>Panel numbers</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>account_balance</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'printers' }"
            v-if="$keycloak.hasRealmRole('root')"
          >
            <v-list-tile-title>Printers</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>print</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'reviews' }">
            <v-list-tile-title>Reviews</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>rate_review</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'reviewSites' }"
            v-if="$keycloak.hasRealmRole('directoryadmin')"
          >
            <v-list-tile-title>Review sites</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>rate_review</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'roles' }"
            v-if="$keycloak.hasRealmRole('root')"
          >
            <v-list-tile-title>Roles</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'servers' }"
            v-if="$keycloak.hasRealmRole('root')"
          >
            <v-list-tile-title>Servers</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>desktop_mac</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'tasks' }">
            <v-list-tile-title>Tasks</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>alarm</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'teams' }"
            v-if="$keycloak.hasRealmRole('directoryadmin')"
          >
            <v-list-tile-title>Teams</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>people</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'entityTypes' }"
            v-if="$keycloak.hasRealmRole('directoryadmin')"
          >
            <v-list-tile-title>Types</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'users' }"
            v-if="$keycloak.hasRealmRole('root')"
          >
            <v-list-tile-title>Users</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>account_circle</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-list-group>
      <v-list-group prepend-icon="menu_book">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Document</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list>
          <v-list-tile :to="{ name: 'uploadsCommon' }">
            <v-list-tile-title>Common uploads</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>cloud_upload</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'documentDiary' }">
            <v-list-tile-title>Document diary</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>description</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'documents' }">
            <v-list-tile-title>Documents</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>description</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'emailTemplates' }"
            v-if="$keycloak.hasRealmRole('documentadmin')"
          >
            <v-list-tile-title>Email templates</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>mail_outline</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'emailTemplateTags' }"
            v-if="$keycloak.hasRealmRole('documentadmin')"
          >
            <v-list-tile-title>Email template tags</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>mail_outline</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'footers' }">
            <v-list-tile-title>Footers</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>horizontal_split</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'scanners' }">
            <v-list-tile-title>Scanners</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>print</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'snippets' }">
            <v-list-tile-title>Snippets</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>receipt</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'templates' }"
            v-if="$keycloak.hasRealmRole('documentadmin')"
          >
            <v-list-tile-title>Templates</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>folder</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'uploads' }">
            <v-list-tile-title>Uploads</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>date_range</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-list-group>
      <v-list-group prepend-icon="email">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Email</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list>
          <v-list-tile :to="{ name: 'emailDiary' }">
            <v-list-tile-title>Email diary</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>date_range</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'emailTags' }">
            <v-list-tile-title>Email tags</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>local_offer</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-list-group>
      <v-list-group prepend-icon="folder">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>File</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list>
          <v-list-tile :to="{ name: 'addEvents' }">
            <v-list-tile-title>Add events</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>event</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'boxes' }">
            <v-list-tile-title>Boxes</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>folder</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'bpTags' }"
            v-if="$keycloak.hasRealmRole('documentadmin')"
          >
            <v-list-tile-title>Buyer persona tags</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>local_offer</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'bpTagsSummary' }">
            <v-list-tile-title>Buyer personae</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>local_offer</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'categories' }"
            v-if="$keycloak.hasRealmRole('root')"
          >
            <v-list-tile-title>Categories</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'categoryYear' }">
            <v-list-tile-title>Category year</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'completions' }">
            <v-list-tile-title>Completions</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>today</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'completionMonth' }">
            <v-list-tile-title>Completion month</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>date_range</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'departments' }">
            <v-list-tile-title>Departments</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>business</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'eventsByDate' }">
            <v-list-tile-title>Events</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>date_range</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'eventTypes' }"
            v-if="$keycloak.hasRealmRole('root')"
          >
            <v-list-tile-title>Event types</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'instructions' }">
            <v-list-tile-title>Instructions</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>date_range</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'matterList' }">
            <v-list-tile-title>Matter list</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'monthlySummary' }">
            <v-list-tile-title>Monthly summary</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'os1' }">
            <v-list-tile-title>OS1</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'os1expiring' }">
            <v-list-tile-title>OS1 expiring</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'os1Monthly' }">
            <v-list-tile-title>OS1 monthly</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'undertakings' }">
            <v-list-tile-title>Undertakings</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-list-group>
      <v-list-group prepend-icon="attach_money">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Fundview</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list>
          <v-list-tile :to="{ name: 'paymentsDiary' }">
            <v-list-tile-title>Payments diary</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>date_range</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'paymentsNotAutolaw' }">
            <v-list-tile-title>Payments not autolaw</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'paymentsUnallocated' }">
            <v-list-tile-title>Payments unallocated</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'paymentsUnsent' }">
            <v-list-tile-title>Payments unsent</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'receiptsDiary' }">
            <v-list-tile-title>Receipts diary</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>date_range</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'receiptsNotAutolaw' }">
            <v-list-tile-title>Receipts not autolaw</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'receiptsUnclaimed' }">
            <v-list-tile-title>Receipts unclaimed</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'receiptsUnverified' }">
            <v-list-tile-title>Receipts unverified</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-list-group>
      <v-list-group prepend-icon="mail_outline">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Message</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list>
          <v-list-tile
            :to="{ name: 'bulletins' }"
            v-if="$keycloak.hasRealmRole('documentadmin')"
          >
            <v-list-tile-title>Bulletins</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>notification_important</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'folders' }">
            <v-list-tile-title>Folders</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>folder</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'news' }">
            <v-list-tile-title>News items</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>local_library</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'testEmail' }"
            v-if="$keycloak.hasRealmRole('documentadmin')"
          >
            <v-list-tile-title>Test email</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>send</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'unreplied' }">
            <v-list-tile-title>Unreplied messages</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>report</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-list-group>
      <v-list-group
        prepend-icon="notifications"
        v-if="$keycloak.hasRealmRole('documentadmin')"
      >
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Notifications</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list>
          <v-list-tile :to="{ name: 'billsUnsent' }">
            <v-list-tile-title>Bills</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>outbox</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'eventsUnsent' }">
            <v-list-tile-title>Events</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>outbox</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'messagesUnsent' }">
            <v-list-tile-title>Messages</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>outbox</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'notesUnsent' }">
            <v-list-tile-title>Notes</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>outbox</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <!-- <v-list-tile :to="{ name: 'notificationsUnsent' }">
            <v-list-tile-title>Notifications (delete)</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>outbox</v-icon>
            </v-list-tile-action>
          </v-list-tile> -->
          <v-list-tile :to="{ name: 'scheduledQuoteEmailsUnsent' }">
            <v-list-tile-title>Quote emails</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>outbox</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'fileResponsesUnsent' }">
            <v-list-tile-title>Responses</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>outbox</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'uploadFilesUnsent' }">
            <v-list-tile-title>Upload files</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>outbox</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'uploadFileSharesUnsent' }">
            <v-list-tile-title>Upload file shares</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>outbox</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-list-group>
      <v-list-group prepend-icon="public">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Operator</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list>
          <v-list-tile :to="{ name: 'operatorClients' }">
            <v-list-tile-title>Operator clients</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'operators' }">
            <v-list-tile-title>Operators</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'pcws' }">
            <v-list-tile-title>Pcws</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-list-group>
      <v-list-group prepend-icon="credit_card">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Payments</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list>
          <v-list-tile :to="{ name: 'bankDetails' }">
            <v-list-tile-title>Bank details</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>account_balance</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'authorise' }">
            <v-list-tile-title>Card payments</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>credit_card</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'findCard' }"
            v-if="$keycloak.hasRealmRole('root')"
          >
            <v-list-tile-title>Find card</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>search</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'issuers' }"
            v-if="$keycloak.hasRealmRole('root')"
          >
            <v-list-tile-title>Issuers</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>business</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'paymentPurposes' }">
            <v-list-tile-title>Purposes</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>assignment</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-list-group>
      <v-list-group prepend-icon="storefront">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Sales</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list>
          <v-list-tile :to="{ name: 'newQuote' }">
            <v-list-tile-title>Add quote</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>add</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'additionals' }"
            v-if="$keycloak.hasRealmRole('salesadmin')"
          >
            <v-list-tile-title>Additionals</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>subtitles</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'averages' }">
            <v-list-tile-title>Averages</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>build</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'quoteCategories' }"
            v-if="$keycloak.hasRealmRole('salesadmin')"
          >
            <v-list-tile-title>Categories</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'changePrices' }">
            <v-list-tile-title>Change prices</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>build</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'descriptions' }"
            v-if="$keycloak.hasRealmRole('salesadmin')"
          >
            <v-list-tile-title>Descriptions</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'diary' }">
            <v-list-tile-title>Diary</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>date_range</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'emailPanelsSales' }"
            v-if="$keycloak.hasRealmRole('salesadmin')"
          >
            <v-list-tile-title>Email panels</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>subtitles</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'emailTemplatesSales' }"
            v-if="$keycloak.hasRealmRole('salesadmin')"
          >
            <v-list-tile-title>Email templates</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>mail_outline</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'salesGroups' }"
            v-if="$keycloak.hasRealmRole('salesadmin')"
          >
            <v-list-tile-title>Groups</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'leadScriptApis' }"
            v-if="$keycloak.hasRealmRole('salesadmin')"
          >
            <v-list-tile-title>Lead script apis</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'leadScripts' }"
            v-if="$keycloak.hasRealmRole('salesadmin')"
          >
            <v-list-tile-title>Lead scripts</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'quoteParameters' }">
            <v-list-tile-title>Parameters</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'quoteParameterTypes' }"
            v-if="$keycloak.hasRealmRole('salesadmin')"
          >
            <v-list-tile-title>Parameter types</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'promotions' }">
            <v-list-tile-title>Promotions</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>card_giftcard</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'quoteTypes' }"
            v-if="$keycloak.hasRealmRole('salesadmin')"
          >
            <v-list-tile-title>Quote types</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'referrals' }">
            <v-list-tile-title>Referrals</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>assignment_turned_in</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'referrerMonth' }">
            <v-list-tile-title>Referrer month</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>date_range</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'scales' }"
            v-if="$keycloak.hasRealmRole('salesadmin')"
          >
            <v-list-tile-title>Scales</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'scaleTypes' }"
            v-if="$keycloak.hasRealmRole('salesadmin')"
          >
            <v-list-tile-title>Scale types</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'quoteSearch' }">
            <v-list-tile-title>Search</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>search</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'undealt' }">
            <v-list-tile-title>Undealt</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>assignment</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-list-group>
      <v-list-group prepend-icon="search" v-if="types">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Search</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list>
          <template v-for="type in types">
            <v-list-tile
              v-if="type.company"
              :key="`company${type.id}`"
              :to="{ name: 'searchCompany', params: { id: type.id } }"
            >
              <v-list-tile-title>{{ type.name }}</v-list-tile-title>
              <v-list-tile-action>
                <v-icon>business</v-icon>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile
              v-if="type.person"
              :key="`individual${type.id}`"
              :to="{ name: 'searchIndividual', params: { id: type.id } }"
            >
              <v-list-tile-title>{{ type.name }}</v-list-tile-title>
              <v-list-tile-action>
                <v-icon>account_box</v-icon>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile
              v-if="type.address == 2"
              :key="`property${type.id}`"
              :to="{ name: 'searchProperty', params: { id: type.id } }"
            >
              <v-list-tile-title>{{ type.name }}</v-list-tile-title>
              <v-list-tile-action>
                <v-icon>home</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
      </v-list-group>
      <v-list-group
        prepend-icon="web"
        v-if="$keycloak.hasRealmRole('documentadmin')"
      >
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>SEO</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list>
          <v-list-tile :to="{ name: 'articles' }">
            <v-list-tile-title>Articles</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>import_contacts</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'counties' }">
            <v-list-tile-title>Counties</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>place</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'countyTemplate' }">
            <v-list-tile-title>County template</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>place</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'imageCollections' }">
            <v-list-tile-title>Image collections</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>insert_photo</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'moveds' }">
            <v-list-tile-title>Moveds</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>call_split</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'populationTemplates' }">
            <v-list-tile-title>Population templates</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>folder</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{ name: 'populations' }">
            <v-list-tile-title>Populations</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>location_city</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "NavigationDrawer",
  computed: {
    ...mapGetters(["navigationDrawerOpen", "navigationDrawerMini"]),
    developmentMode() {
      return process.env.NODE_ENV === "development";
    }
  },
  data() {
    return {
      admins: [
        ["Management", "people_outline"],
        ["Settings", "settings"]
      ],
      cruds: [
        ["Create", "add"],
        ["Read", "insert_drive_file"],
        ["Update", "update"],
        ["Delete", "delete"]
      ],
      development: false,
      types: null
    };
  },
  methods: {
    ...mapActions(["toggleNavigationDrawerMini"]),
    fetchDevelopment() {
      nbmlaw
        .get(`/cors/admin/extras/development`)
        .then((response) => {
          // console.log(response.data);
          this.development = response.data;
        })
        .catch(() => {});
    },
    fetchTypes() {
      nbmlaw.get(`/cors/admin/directory/types`).then((response) => {
        // console.log(response.data);
        this.types = response.data;
      });
    }
  },
  created() {
    this.fetchDevelopment();
    this.fetchTypes();
  }
};
</script>

  <style>
.developmentMarker {
  background-color: #ff0000;
  color: white;
}
</style>
